import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage3 from './components/Homepage3';
import LeadGenerationPage from './pages/LeadGenerationPage';
import MobileDevelopmentPage from './pages/MobileDevelopmentPage';
import WebsiteDevelopmentPage from './pages/WebsiteDevelopmentPage';
import ContactPage from './pages/ContactPage';
import MetaAdsPage from './pages/MetaAdsPage';
import GoogleAdsPage from './pages/GoogleAdsPage';
import AmazonAdsPage from './pages/AmazonAdsPage';
import IndustriesPage from './pages/IndustriesPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import DigitalMarketingPage from './pages/DigitalMarketingPage';
import SocialMediaPage from './pages/SocialMediaPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import PortfolioPage from './pages/PortfolioPage';
import QuotePage from './pages/QuotePage';
import ConsultationPage from './pages/ConsultationPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import DataProtectionPage from './pages/DataProtectionPage';
import AccessibilityPage from './pages/AccessibilityPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage3 />} />
        <Route path="/lead-generation" element={<LeadGenerationPage />} />
        <Route path="/mobile-development" element={<MobileDevelopmentPage />} />
        <Route path="/website-development" element={<WebsiteDevelopmentPage />} />
        <Route path="/digital-marketing" element={<DigitalMarketingPage />} />
        <Route path="/social-media" element={<SocialMediaPage />} />
        <Route path="/meta-ads" element={<MetaAdsPage />} />
        <Route path="/google-ads" element={<GoogleAdsPage />} />
        <Route path="/amazon-ads" element={<AmazonAdsPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/consultation" element={<ConsultationPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/data-protection" element={<DataProtectionPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="*" element={<Homepage3 />} />
      </Routes>
    </Router>
  );
}

export default App;